import { Component, OnInit } from '@angular/core';
import * as CanvasJS from './../../assets/js/canvasjs.min.js';
import { Observable, Subject, timer, Subscription, EMPTY } from 'rxjs';
import { AvbAverbTempo } from '../_classes/avb-averb-tempo';
import { MatTableDataSource } from '@angular/material/table';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { tap, take, catchError } from 'rxjs/operators';
import { Util } from '../_classes/util';
import { ContagemTempoServico } from '../_classes/contagem-tempo-servico';
import { Provimento } from '../_classes/provimento';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-tempo-servico',
  templateUrl: './tempo-servico.component.html',
  styleUrls: ['./tempo-servico.component.scss'],
})
export class TempoServicoComponent implements OnInit {
  private readonly recurso: string = 'tempo-servico'; //mesmo que a rota
  publicoTrt: ContagemTempoServico = null;
  publicoAverbado: ContagemTempoServico = null;
  militarAverbado: ContagemTempoServico = null;
  inssAverbado: ContagemTempoServico = null;

  carregandoTotal = false;
  carregandoAverbacao = false;
  carregandoProv = false;

  displayedColumns: string[] = [
    'dtInicioAverb',
    'tpContTpServ',
    'qtdeTotDiasLiq',
    'orgAtivPriv',
  ];

  iServidor: Subscription;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<AvbAverbTempo[]>;
  idataSourceProv: Subscription;
  dataSource: MatTableDataSource<AvbAverbTempo>;

  itensAjuda = [
    {
      titulo: 'Período',
      texto: 'Período averbado',
    },
    {
      titulo: 'Tipo',
      texto: 'Tipo de contribuição - militar, INSS (privado) ou público',
    },
    {
      titulo: 'Tempo',
      texto: 'O período que foi averbado em dias, meses e anos',
    },
    {
      titulo: 'Local',
      texto: 'Nome do local/órgão de onde o período foi averbado',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {
    this.publicoTrt = new ContagemTempoServico();
    this.publicoTrt.tipo = 'F';
    this.publicoAverbado = new ContagemTempoServico();
    this.publicoAverbado.tipo = 'F';
    this.militarAverbado = new ContagemTempoServico();
    this.militarAverbado.tipo = 'M';
    this.inssAverbado = new ContagemTempoServico();
    this.inssAverbado.tipo = 'P';

    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit() {
    this.atualizar();
  }

  atualizarCarregando() {
    this.carregandoTotal = this.carregandoAverbacao || this.carregandoProv;
    if (!this.carregandoTotal) {
      this.iniciarGrafico();
    }
  }

  executarAoCarregarDatasourceProv(x: Provimento[]) {
    //console.log('executarAoCarregarDatasourceProv', x);
    if (x) {
      x.forEach((prov) => {
        //console.log('PROV - listando', prov);
        const date1 = new Date(prov.dtExercicio);
        let date2: Date;
        if (prov.dtFim) {
          date2 = new Date(prov.dtFim);
        } else {
          date2 = new Date();
        }
        //console.log('DataI', date1);
        //console.log('DataF', date2);
        // To calculate the time difference of two dates
        const diferencaEmTempo = date2.getTime() - date1.getTime();
        //console.log('DiffEmTempo', diferencaEmTempo);
        // To calculate the no. of days between two dates
        let diferencaEmDias = Math.floor(diferencaEmTempo / (1000 * 3600 * 24));
        //console.log('DiffEmDias', diferencaEmDias);
        if (diferencaEmDias > 0) {
          diferencaEmDias = diferencaEmDias + 1;
        }
        this.publicoTrt.dias = this.publicoTrt.dias + diferencaEmDias;
        this.publicoTrt.totalEmDias =
          this.publicoTrt.totalEmDias + diferencaEmDias;
        //console.log('publicoTrt.dias', this.publicoTrt.dias);
      });
      this.publicoTrt = this.atualizarContagem(this.publicoTrt);
    }
    this.carregandoProv = false;
    this.atualizarCarregando();
  }

  iniciarGrafico() {
    const chart = new CanvasJS.Chart('chart1', {
      animationEnabled: true,
      exportEnabled: true,
      culture: 'pt',
      title: {
        text: 'TOTAL AVERBADO',
        fontFamily: "Roboto,'Helvetica Neue',Arial",
      },
      subtitles: [
        {
          text: '(em dias)',
          fontFamily: 'Arial',
        },
      ],
      legend: {
        cursor: 'pointer',
        itemclick: this.explodePie,
      },

      data: [
        {
          type: 'doughnut',
          innerRadius: 60,
          showInLegend: true,
          toolTipContent: '<b>{name}</b>: {y} (#percent%)',
          indexLabel: '{name} - #percent%',
          explodeOnClick: true,
          dataPoints: [
            {
              y: this.publicoTrt.totalEmDias,
              name: 'Público TRT24',
              color: '#5cb85c',
            },
            {
              y: this.publicoAverbado.totalEmDias,
              name: 'Averb Federal',
              color: '#428bca',
            },
            {
              y: this.militarAverbado.totalEmDias,
              name: 'Averb Militar',
              color: '#d9534f',
            },
            {
              y: this.inssAverbado.totalEmDias,
              name: 'Averb INSS',
              color: '#f0ad4e',
            },
          ],
        },
      ],
    });
    chart.render();
  }

  explodePie(e) {
    if (
      typeof e.dataSeries.dataPoints[e.dataPointIndex].exploded ===
        'undefined' ||
      !e.dataSeries.dataPoints[e.dataPointIndex].exploded
    ) {
      e.dataSeries.dataPoints[e.dataPointIndex].exploded = true;
    } else {
      e.dataSeries.dataPoints[e.dataPointIndex].exploded = false;
    }
    e.chart.render();
  }

  listar() {
    if (this.env.servidor.servidorSrh2) {
      UtilLogAcessoSistema.registrarAcessoAoRecurso(
        this.recurso,
        this.env.servidor.idServidor,
        this.service
      );

      this.dataSource$ = this.service
        .listarAverbacao(this.env.servidor.servidorSrh2.matServidor)
        .pipe(
          tap((a) => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return EMPTY;
          })
        );

      this.idataSourceProv = this.service
        .listarProvimento(this.env.servidor.idServidor)
        .pipe(take(1))
        .subscribe((a) => this.executarAoCarregarDatasourceProv(a));
    } else {
      this.carregandoAverbacao = false;
    }
  }

  atualizar() {
    this.carregandoAverbacao = true;
    this.atualizarCarregando();
    this.t = timer(20000).subscribe((v) => {
      if (this.carregandoAverbacao) {
        this.carregandoAverbacao = false;
        this.atualizarCarregando();
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });

    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  executarAoCarregarDatasource(x: AvbAverbTempo[]) {
    //console.log('executarAoCarregarDatasource', x);
    if (x) {
      this.dataSource = new MatTableDataSource<AvbAverbTempo>(x);
      x.forEach((av) => {
        //console.log('AVERB - listando', av);
        switch (av.tpContTpServ) {
          case 'F': {
            this.publicoAverbado.dias = this.publicoAverbado.dias + av.diasLiq;
            this.publicoAverbado.meses = this.publicoAverbado.meses + av.mesLiq;
            this.publicoAverbado.anos = this.publicoAverbado.anos + av.anoLiq;
            this.publicoAverbado.totalEmDias =
              this.publicoAverbado.totalEmDias + av.qtdeTotDiasLiq;
            break;
          }
          case 'M': {
            this.militarAverbado.dias = this.militarAverbado.dias + av.diasLiq;
            this.militarAverbado.meses = this.militarAverbado.meses + av.mesLiq;
            this.militarAverbado.anos = this.militarAverbado.anos + av.anoLiq;
            this.militarAverbado.totalEmDias =
              this.militarAverbado.totalEmDias + av.qtdeTotDiasLiq;
            break;
          }
          case 'P': {
            this.inssAverbado.dias = this.inssAverbado.dias + av.diasLiq;
            this.inssAverbado.meses = this.inssAverbado.meses + av.mesLiq;
            this.inssAverbado.anos = this.inssAverbado.anos + av.anoLiq;
            this.inssAverbado.totalEmDias =
              this.inssAverbado.totalEmDias + av.qtdeTotDiasLiq;
            break;
          }
        }
      });
      this.publicoAverbado = this.atualizarContagem(this.publicoAverbado);
      this.publicoTrt = this.atualizarContagem(this.publicoTrt);
      this.inssAverbado = this.atualizarContagem(this.inssAverbado);
      this.militarAverbado = this.atualizarContagem(this.militarAverbado);
    }
    this.carregandoAverbacao = false;
    this.atualizarCarregando();
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }

  atualizarContagem(contagem: ContagemTempoServico): ContagemTempoServico {
    //console.log('CONTAGEM - INICIO');
    //console.log('anos: ', contagem.anos);
    //console.log('meses: ', contagem.meses);
    //console.log('dias: ', contagem.dias);
    if (contagem.dias > 30) {
      let v = Math.floor(contagem.dias / 30);
      contagem.meses = contagem.meses + v;
      contagem.dias = contagem.dias - v * 30;
    }

    if (contagem.meses > 12) {
      let v = Math.floor(contagem.meses / 12);
      contagem.anos = contagem.anos + v;
      contagem.meses = contagem.meses - v * 12;
    }
    //    console.log('CONTAGEM - FIM');
    //console.log('anos: ', contagem.anos);
    //console.log('meses: ', contagem.meses);
    //console.log('dias: ', contagem.dias);
    return contagem;
  }

  resumo(contagem: ContagemTempoServico): string {
    let r: string = '';
    if (contagem.anos) {
      if (contagem.anos === 1) {
        r = '1 ano, ';
      } else {
        r = contagem.anos + ' anos, ';
      }
    } else {
      r = 'ZERO anos, ';
    }

    if (contagem.meses) {
      if (contagem.meses === 1) {
        r = r + '1 mês e ';
      } else {
        r = r + contagem.meses + ' meses e ';
      }
    } else {
      r = r + 'ZERO meses e ';
    }

    if (contagem.dias) {
      if (contagem.dias === 1) {
        r = r + '1 dia';
      } else {
        r = r + contagem.dias + ' dias';
      }
    } else {
      r = r + 'ZERO dias';
    }

    return r;
  }
}
